import './App.css';

import { createFFmpeg } from '@ffmpeg/ffmpeg'
import React, { Component } from 'react';

const defaultLogger = ({ message }) => console.debug(message);
const ffmpeg = createFFmpeg({ logger: defaultLogger, log: false });

let promise = null;

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            quality: 4,
        }

        this.fileInput = React.createRef();
    }

    async componentDidMount() {
        await ffmpeg.load();
    }

    async componentDidUpdate(prevProps, prevState) {
        if ((this.state.file && this.state.file !== prevState.file) || (this.state.quality !== prevState.quality)) {
            this.convert();
        }
    }

    async convertPromise() {
        let file = this.state.file;
        if (!file) return;

        if (this.state.url) {
            URL.revokeObjectURL(this.state.url);
        }

        let properties = this.state.properties;
        if (!properties) {
            properties = await this.fetchProperties(file);
        } else {
            // delete the original image
            try { ffmpeg.FS('unlink', file.name); } catch (e) { }
        }

        // this mess calculates a bitrate based on the image size and quality slider based on a bunch 
        // of trial and error constants that mostly work
        let bitrate = Math.min(Math.max(7, Math.floor(7 * (properties.width * properties.height) / 250000)), 28);
        let quality = Math.floor(bitrate + (Math.pow(1.66, 17 - this.state.quality)));
        console.warn('bitrate', bitrate);
        console.warn('quality', quality);

        // ffmpeg the image to a video, then back to an image
        await ffmpeg.run('-i', 'input.png', '-vframes', '1', '-vf', `scale=${properties.width}x${properties.height}`, '-c:v', 'libx264', '-b:v', `${quality}k`, 'out.mp4');
        await ffmpeg.run('-i', 'out.mp4', '-vframes', '1', 'out.jpg');

        const data = ffmpeg.FS('readFile', 'out.jpg');
        const url = URL.createObjectURL(new Blob([data.buffer], { type: 'image/jpg' }));
        this.setState({ url });

        promise = null;
    }

    async fetchProperties(fileName) {
        let stdout = '';
        let logCallback = ({ type, message }) => {
            if (type === 'fferr')
                stdout += message + '\n';
        };

        ffmpeg.setLogger(logCallback);
        ffmpeg.setLogging(true);

        await ffmpeg.run('-i', fileName, '-vframes', '1', '-f', 'null', '-');

        ffmpeg.setLogging(true);
        ffmpeg.setLogger(defaultLogger);

        // find Video: ... {digits}x{digits} in the output
        const match = stdout.match(/Video:.*\s(\d+)x(\d+)/);
        let width = parseInt(match[1]);
        let height = parseInt(match[2]);

        console.warn(`width: ${width}, height: ${height}`);

        let useSmall = false;

        // resize the image to a maximum of 1500x1500 preserving aspect ratio
        if (width > 2000 || height > 2000) {
            let scale = Math.min(2000 / width, 2000 / height);
            width = Math.floor(width * scale);
            height = Math.floor(height * scale);

            console.error("resizing to", width, height);

            await ffmpeg.run('-i', fileName, '-vframes', '1', '-vf', `scale=${width}x${height}`, "input.png");
        }
        else {
            await ffmpeg.run('-i', fileName, '-vframes', '1', "input.png");
        }

        const buffer = ffmpeg.FS('readFile', 'input.png');
        const input = URL.createObjectURL(new Blob([buffer], { type: 'image/png' }));

        // round up to the nearest 4 to keep x264 happy
        width = Math.ceil(width / 4) * 4;
        height = Math.ceil(height / 4) * 4;

        this.setState({ input, properties: { width, height, useSmall } });
        return { width, height };
    }

    setFile() {
        // delete the existing file
        if (this.state.file) {
            ffmpeg.FS('unlink', this.state.file);
        }

        const file = this.fileInput.current.files[0];
        if (!file) {
            this.setState({ file: null, url: null, input: null, properties: null });
            return;
        }

        const reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = async () => {
            try {
                // fetch image width and height
                const buffer = new Uint8Array(reader.result);
                ffmpeg.FS('writeFile', file.name, buffer);

                this.setState({ file: file.name, url: null, input: null, properties: null });
            }
            catch (e) {
            }
        }
    }

    convert() {
        // we want to wait until the last convertPromise() call is done before starting a new one
        // we can't cancel the previous one
        if (promise) {
            promise.then(() => {
                promise = this.convertPromise();
            }).catch(() => {
                promise = this.convertPromise();
            });
        }
        else {
            promise = this.convertPromise();
        }

    }

    render() {
        return (
            <div className="App">
                <h1>Image crustifier</h1>

                <div>
                    <input type="file" ref={this.fileInput} onChange={this.setFile.bind(this)} />
                </div>

                <div>
                    <label>Crustiness: {this.state.quality}</label>
                    <input type="range" min={0} max={16} value={this.state.quality} onChange={(e) => { this.setState({ quality: e.target.valueAsNumber }); }} />
                </div>

                <div className='image-preview'>
                    {this.state.input ? <img src={this.state.input} alt='Original' /> : null}
                    {this.state.url ? <img src={this.state.url} alt='Crunched' /> : null}
                </div>
            </div>
        );
    }
}

export default App;